<template>
  <div id="prepost-print" class="p-1">
    <div v-if="tag">
      <div class="row">
        <div class="col-3">
          <canvas id="mycanvas"></canvas>
        </div>
        <div
          class="col-7 d-flex justify-content-between"
          style="line-height: 1"
        >
          <div>
            <img src="/logo-correios-256.png" height="20" /><br />
            Contrato:
          </div>
          <div>
            <small
              >NF: {{ nfeNumber || "N/A" }}<br />
              Pedido: <br />Volume: {{ tag.volume || "N/A" }}<br />Peso:
              {{ tag.weight || "N/A" }}</small
            >
          </div>
        </div>
        <div class="col-2"></div>
      </div>
      <div class="row">
        <div class="col-9">
          <barcode
            v-bind:value="tag.tag"
            width="2"
            height="80"
            text-position="top"
          >
            Falha na geração do código de barras
          </barcode>
        </div>
        <div class="col-3 text-right">
          <small
            ><br />
            <b
              >MP {{ tag.mdp || "N/A" }}<br />
              AR {{ tag.register || "N/A" }}</b
            ></small
          >
        </div>
      </div>
      <div class="row">
        <div class="col-2"><small>Recebedor</small></div>
        <div class="col-10 border-bottom border-dark"></div>
      </div>
      <div class="row">
        <div class="col-2"><small>Assinatura</small></div>
        <div class="col-4 border-bottom border-dark"></div>
        <div class="col-2"><small>Documento</small></div>
        <div class="col-4 border-bottom border-dark"></div>
      </div>
      <div class="row border border-dark mt-1">
        <div class="col-6">
          <small
            ><b>{{ tag.care || "Sem nome de destinatário" }}</b
            ><br />
            {{ tag.destinyaddress }}, {{ tag.destinynumber || "s/n" }}<br />
            {{ tag.destinycomplement }}<br />
            <b>{{ tag.destinyzipcode }}</b> {{ tag.destinycity }}/{{
              tag.destinystate
            }}
          </small>
        </div>
        <div class="col-6">
          <barcode
            v-if="tag"
            v-bind:value="tag.destinyzipcode.replaceAll('-', '')"
            width="2"
            height="80"
            display-value="false"
          >
            Falha na geração do código de barras
          </barcode>
        </div>
      </div>
      <div class="row border border-dark">
        <div class="col-12" style="line-height: 1">
          <small
            ><b>Remetente:</b>{{ tag.contact || "N/A" }}<br />
            {{ tag.sourceaddress }}, {{ tag.sourcenumber }}
            {{ tag.sourcecomplement }}<br />
            <b>{{ tag.sourcezipcode }}</b> {{ tag.sourcecity }}/{{
              tag.sourcestate
            }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { PrepostService } from "@/services/customers/prepost.services";
import { i18n } from "@/plugin/i18n";
import VueBarcode from "vue-barcode";
import bwipjs from "bwip-js";

export default {
  name: "prepost-print",

  components: {
    barcode: VueBarcode,
  },

  data() {
    return {
      tag: null,
    };
  },

  mounted() {
    const vm = this;
    const loading = vm.$loading({
      lock: true,
      text: i18n.tc("carregando"),
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    PrepostService.tag(this.$route.params.id)
      .then((response) => {
        this.tag = response;
        this.createDataMatrix();
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      })
      .finally(() => loading.close());
  },

  computed: {
    nfeNumber() {
      if (!this.tag) return "";
      let nfe = this.tag.nfe;
      try {
        if (typeof nfe === "string") nfe = JSON.parse(nfe);
      } catch (e) {
        nfe = null;
      }
      return (nfe && (nfe.number || nfe.nfeNumber)) || this.tag.invoice || "";
    },
  },

  methods: {
    createDataMatrix() {
      setTimeout(() => {
        this.canvas = bwipjs.toCanvas("mycanvas", {
          bcid: "datamatrix",
          text: this.tag.destinyzipcode + this.tag.sourcezipcode + this.tag.tag,
          scale: 2,
          textxalign: "left",
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
#prepost-print {
  color: #000;
  font-family: "Arial";
  background-color: white;
  width: 28rem;
  border: 1px solid #000;

  .row {
    margin: 0;
  }
}
</style>
